import { NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import {
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import {
    AvailableLangs,
    TranslocoModule,
    TranslocoService,
} from '@jsverse/transloco';
import { take } from 'rxjs';

@Component({
    selector: 'languages',
    templateUrl: './languages.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'languages',
    imports: [
    MatButtonModule,
    MatMenuModule,
    NgTemplateOutlet,
    TranslocoModule
]
})
export class LanguagesComponent implements OnInit, OnDestroy {
    availableLangs: AvailableLangs;
    activeLang: string;
    flagCodes: any;

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private _translocoService: TranslocoService
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Get the available languages from transloco
        this.availableLangs = this._translocoService.getAvailableLangs();

        // Subscribe to language changes
        this._translocoService.langChanges$.subscribe((activeLang) => {
            // Get the active lang
            this.activeLang = activeLang;

            // Update the navigation
            // this._updateNavigation(activeLang);
            this._updateaAllNavigations();
        });

        // Set the country iso codes for languages for flags
        this.flagCodes = {
            en: 'us',
            // 'tr': 'tr',
            de: 'de',
        };
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Set the active lang
     *
     * @param lang
     */
    setActiveLang(lang: string): void {
        // Set the active lang
        this._translocoService.setActiveLang(lang);
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    _updateaAllNavigations() {
        this._updateNavigation('mainNavigation');
        this._updateNavigation('device-insights-navigation');
    }

    /**
     * Update the navigation
     *
     * @param lang
     * @private
     */
    private _updateNavigation(navigationName: string): void {
        // For the demonstration purposes, we will only update the Dashboard names
        // from the navigation but you can do a full swap and change the entire
        // navigation data.
        //
        // You can import the data from a file or request it from your backend,
        // it's up to you.

        // Get the component -> navigation data -> item
        const navComponent =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                navigationName
            );

        console.log(navComponent);
        // Return if the navigation component does not exist
        if (!navComponent) {
            return null;
        }

        // Get the flat navigation data
        const navigation = navComponent.navigation;

        const groupIds = navigation.map((group) => group.id);
        const children = navigation.map((group) =>
            group.children.map((nav) => nav.id)
        );

        let navChildrenIds = [];
        navigation.forEach((group) =>
            group.children.forEach((nav) =>
                nav.children?.forEach((c) => navChildrenIds.push(c.id))
            )
        );
        const childrenIds = [].concat(...children);
        const navIds = [...groupIds, ...childrenIds, ...navChildrenIds];
        navIds.forEach((id) => {
            const idLength = id.split('.').length;
            const tag = idLength > 1 ? id.split('.')[idLength - 1] : id;
            this.update(id, tag, navigation, navComponent);
        });

        // // Get the Project dashboard item and update its title
        // const projectDashboardItem = this._fuseNavigationService.getItem('dashboards.project', navigation);
        // if ( projectDashboardItem )
        // {
        //     this._translocoService.selectTranslate('Project').pipe(take(1))
        //         .subscribe((translation) =>
        //         {
        //             // Set the title
        //             projectDashboardItem.title = translation;

        //             // Refresh the navigation component
        //             navComponent.refresh();
        //         });
        // }
    }

    private update(itemID, tag: string, navigation, navComponent) {
        // Get the dashboard item and update its title
        const dashboardItem = this._fuseNavigationService.getItem(
            itemID,
            navigation
        );
        if (dashboardItem) {
            this._translocoService
                .selectTranslate(tag.toUpperCase())
                .pipe(take(1))
                .subscribe((translation) => {
                    // Set the title
                    dashboardItem.title = translation;

                    // Refresh the navigation component
                    navComponent.refresh();
                });
        }
    }
}
